import React, { useRef, useEffect } from 'react';
import Header, { HeaderProps } from 'molecules/Header/Header/Header';
import InfoBar from 'molecules/InfoBar/InfoBar';
import { PositionContainer, RelativeContainer } from './HeaderAndInfoBarWrapper.styles';
import useElementResize from 'src/hooks/useElementResize';

interface HeaderAndInfoBarWrapperProps {
  headerProps: HeaderProps;
}

const HeaderAndInfoBarWrapper = ({ headerProps }: HeaderAndInfoBarWrapperProps): JSX.Element => {
  const positionRef = useRef<HTMLDivElement>(null);
  const { height } = useElementResize(positionRef);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    document.documentElement.style.setProperty('--header-height', `${height || 80}px`);
  }, [height]);

  return (
    <RelativeContainer id='header-and-info-bar-wrapper'>
      <PositionContainer ref={positionRef}>
        <InfoBar />
        <Header {...headerProps} />
      </PositionContainer>
    </RelativeContainer>
  );
};

export default HeaderAndInfoBarWrapper;
